import { required, numeric, integer, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      amount: {
        required: helpers.withMessage(i18n.global.t('Please enter a amount.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the amount.'), numeric),
        minValue: helpers.withMessage(i18n.global.t('Please enter a valid must be at least 1.'), minValue(1))
      },
      shift_transaction_category_id: {
        required: helpers.withMessage(i18n.global.t('Please enter a category.'), required),
        integer: helpers.withMessage(i18n.global.t('Please enter a valid number.'), integer)
      },
      note: {
      }
    }
  }
};
